import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '📩 Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i file PDF. Accesso immediato, nessuna attesa. Puoi usarli già dalla prossima lezione.'
}, {
  q: '🏫 Funziona sia per le Medie che per le Superiori?',
  a: 'Sì. Copre la Secondaria di I e II Grado fino alla Maturità.'
}, {
  q: '👨‍🎓 Ho studenti con BES o DSA?',
  a: 'È il punto di forza del sistema. Il Bonus 1 include mappe, PDP e schede compensative conformi alla Legge 170/2010.'
}, {
  q: '📋 È allineato al MIM?',
  a: 'Sì. Ogni tomo è costruito sulle Indicazioni Nazionali, il PECUP e i quadri di riferimento 2025-2026.'
}, {
  q: '✏️ I materiali sono editabili?',
  a: "I PDF sono pronti all'uso immediato. Le griglie e i modelli UDA sono disponibili anche in Word editabile."
}, {
  q: '⏳ Per quanto tempo ho accesso?',
  a: 'Per sempre. Aggiornamenti MIM inclusi e gratuiti via email.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-12 uppercase text-brand-cream" data-id="element-81">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-84">
                <span className="font-bold text-brand-cream pr-4" data-id="element-85">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 pt-0 text-gray-400 font-medium leading-relaxed" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}